import { get } from 'svelte/store';
import { format, locale } from 'svelte-i18n';

/**
 * svelte-i18n throws if `format()` runs before `init()` has set a locale.
 * Use this from helpers that can run during account bootstrap (slow network,
 * non-English profile language still loading).
 */
export function formatWhenLocaleReady(key: string, options?: { default?: string }): string {
	const defaultTitle = options?.default ?? key;

	if (!get(locale)) {
		return defaultTitle;
	}

	return get(format)(key, { default: defaultTitle });
}
